import { SaleTransactionType } from 'api-hooks/refund/refund';

import { FormType } from '../form-type';

export const filteringReleaseSaleItems = (values: FormType) => {
  let saleItems: { id: string; refundPrice: number }[] = [];
  let saleAddOns: { id: string; refundPrice: number }[] = [];
  let purchaseItems: { id: string; refundPrice: number }[] = [];
  let purchaseAddOns: { id: string; refundPrice: number }[] = [];

  if (values.transactionSaleType === SaleTransactionType.FLIGHT) {
    saleItems = values.flightSales
      .filter((fs) => fs.flightSaleGuests.some((fst) => fst.isSelected))
      .map((fs) => fs.flightSaleGuests.filter((fsg) => fsg.isSelected))
      .flat()
      .map((fs) => ({ id: fs.id, refundPrice: fs.refundPrice }));

    saleAddOns = values.flightSales
      .filter((fs) => fs.flightSaleAddOns.some((fst) => fst.isSelected))
      .map((fs) => fs.flightSaleAddOns.filter((fsao) => fsao.isSelected))
      .flat()
      .map((fs) => ({ id: fs.id, refundPrice: fs.refundPrice }));

    purchaseItems = values.flightPurchases
      .filter((fp) => fp.flightPurchaseGuests.some((fpt) => fpt.isSelected))
      .map((fp) => fp.flightPurchaseGuests.filter((fpg) => fpg.isSelected))
      .flat()
      .map((fp) => ({ id: fp.id, refundPrice: fp.refundPrice }));

    purchaseAddOns = values.flightPurchases
      .filter((fp) => fp.flightPurchaseGuests.some((fpt) => fpt.isSelected))
      .map((fp) => fp.flightPurchaseAddOns.filter((fpao) => fpao.isSelected))
      .flat()
      .map((fp) => ({ id: fp.id, refundPrice: fp.refundPrice }));
  }

  if (values.transactionSaleType === SaleTransactionType.HOTEL) {
    saleItems = values.hotelSales
      .filter((hs) => hs.isSelected)
      .map((hs) => hs.hotelSaleHotels)
      .flat()
      .map((hs) => ({ id: hs.id, refundPrice: hs.refundPrice }));

    saleAddOns = values.hotelSales
      .filter((hs) => hs.isSelected)
      .map((hs) => hs.hotelSaleAddOns.filter((hsao) => hsao.isSelected))
      .flat()
      .map((hs) => ({ id: hs.id, refundPrice: hs.refundPrice }));

    purchaseItems = values.hotelPurchases
      .filter((hp) => hp.isSelected)
      .map((hp) => hp.hotelPurchaseHotels)
      .flat()
      .map((hp) => ({ id: hp.id, refundPrice: hp.refundPrice }));

    purchaseAddOns = values.hotelPurchases
      .filter((hp) => hp.isSelected)
      .map((hp) => hp.hotelPurchaseAddOns.filter((hpao) => hpao.isSelected))
      .flat()
      .map((hp) => ({ id: hp.id, refundPrice: hp.refundPrice }));
  }

  if (values.transactionSaleType === SaleTransactionType.ACTIVITY) {
    saleItems = values.activitySales
      .filter((as) => as.activitySaleGuests.some((ast) => ast.isSelected))
      .map((as) => as.activitySaleGuests.filter((asg) => asg.isSelected))
      .flat()
      .map((as) => ({ id: as.id, refundPrice: as.refundPrice }));

    saleAddOns = values.activitySales
      .filter((as) => as.activitySaleAddOns.some((ast) => ast.isSelected))
      .map((as) => as.activitySaleAddOns.filter((asao) => asao.isSelected))
      .flat()
      .map((as) => ({ id: as.id, refundPrice: as.refundPrice }));

    purchaseItems = values.activityPurchases
      .filter((as) => as.activityPurchaseGuests.some((ast) => ast.isSelected))
      .map((ap) => ap.activityPurchaseGuests.filter((apg) => apg.isSelected))
      .flat()
      .map((ap) => ({ id: ap.id, refundPrice: ap.refundPrice }));

    purchaseAddOns = values.activityPurchases
      .filter((as) => as.activityPurchaseAddOns.some((ast) => ast.isSelected))
      .map((ap) => ap.activityPurchaseAddOns.filter((apao) => apao.isSelected))
      .flat()
      .map((ap) => ({ id: ap.id, refundPrice: ap.refundPrice }));
  }

  if (values.transactionSaleType === SaleTransactionType.CRUISE) {
    saleItems = values.cruiseSales
      .filter((cs) => cs.cruiseSaleDetails.some((cst) => cst.isSelected))
      .map((cs) => cs.cruiseSaleDetails.filter((csg) => csg.isSelected))
      .flat()
      .map((cs) => ({ id: cs.id, refundPrice: cs.refundPrice }));

    saleAddOns = values.cruiseSales
      .filter((cs) => cs.cruiseSaleAddOns.some((cst) => cst.isSelected))
      .map((cs) => cs.cruiseSaleAddOns.filter((csao) => csao.isSelected))
      .flat()
      .map((cs) => ({ id: cs.id, refundPrice: cs.refundPrice }));

    purchaseItems = values.cruisePurchases
      .filter((cp) => cp.cruisePurchaseDetails.some((cpt) => cpt.isSelected))
      .map((cp) => cp.cruisePurchaseDetails.filter((cpg) => cpg.isSelected))
      .flat()
      .map((cp) => ({ id: cp.id, refundPrice: cp.refundPrice }));

    purchaseAddOns = values.cruisePurchases
      .filter((cp) => cp.cruisePurchaseAddOns.some((cpt) => cpt.isSelected))
      .map((cp) => cp.cruisePurchaseAddOns.filter((cpao) => cpao.isSelected))
      .flat()
      .map((cp) => ({ id: cp.id, refundPrice: cp.refundPrice }));
  }

  if (values.transactionSaleType === SaleTransactionType.DOCUMENT) {
    saleItems = values.documentSales
      .filter((ds) => ds.documentSaleGuests.some((dst) => dst.isSelected))
      .map((ds) => ds.documentSaleGuests.filter((dsg) => dsg.isSelected))
      .flat()
      .map((ds) => ({ id: ds.id, refundPrice: ds.refundPrice }));

    saleAddOns = values.documentSales
      .filter((ds) => ds.documentSaleAddOns.some((dst) => dst.isSelected))
      .map((ds) => ds.documentSaleAddOns.filter((dsao) => dsao.isSelected))
      .flat()
      .map((ds) => ({ id: ds.id, refundPrice: ds.refundPrice }));

    purchaseAddOns = values.documentPurchases
      .filter((dp) => dp.documentPurchaseAddOns.some((dpt) => dpt.isSelected))
      .map((dp) => dp.documentPurchaseAddOns.filter((dpao) => dpao.isSelected))
      .flat()
      .map((dp) => ({ id: dp.id, refundPrice: dp.refundPrice }));

    purchaseItems = values.documentPurchases
      .filter((dp) => dp.documentPurchaseGuests.some((dpt) => dpt.isSelected))
      .map((dp) => dp.documentPurchaseGuests.filter((dpg) => dpg.isSelected))
      .flat()
      .map((dp) => ({ id: dp.id, refundPrice: dp.refundPrice }));
  }

  if (values.transactionSaleType === SaleTransactionType.PRODUCT) {
    saleItems = values.productSales
      .filter((ps) => ps.isSelected)
      .map((ps) => ({
        id: ps.id,
        refundPrice: ps.refundPrice,
      }));

    saleAddOns = [];
  }

  if (values.transactionSaleType === SaleTransactionType.TOUR) {
    saleItems = values.tourSales
      .filter((ts) => ts.tourSaleGuests.some((tst) => tst.isSelected))
      .map((ts) => ts.tourSaleGuests.filter((tsg) => tsg.isSelected))
      .flat()
      .map((ts) => ({ id: ts.id, refundPrice: ts.refundPrice }));
    saleAddOns = values.tourSales
      .filter((ts) => ts.tourSaleAddOns.some((tst) => tst.isSelected))
      .map((ts) => ts.tourSaleAddOns.filter((tsao) => tsao.isSelected))
      .flat()
      .map((ts) => ({ id: ts.id, refundPrice: ts.refundPrice }));
  }

  return { saleItems, saleAddOns, purchaseItems, purchaseAddOns };
};
